import React from 'react';
import NotificationsPanelContainer from './NotificationsPanelContainer';
import NotificationsTable from './NotificationsTable';

const NotificationsPanelFull = ({
  category,
  code,
  onChange,
  url,
}) => (
  <NotificationsPanelContainer
    category={category}
    className="aridhia-notifications-panel-full"
    code={code}
    onChange={onChange}
    url={url}
  >
    <NotificationsTable category={category} code={code} />
  </NotificationsPanelContainer>
);

export default NotificationsPanelFull;
